export interface DexUserInfo {
  id?: number;
  name?: string;
  email?: string;
  role?: string;
  descomplicaId?: string;
}

export interface DexUserState {
  dexUser: DexUserInfo;
}

const dexUser: DexUserState = {
  dexUser: {
    id: undefined,
    name: undefined,
    email: undefined,
    role: undefined,
    descomplicaId: undefined,
  },
};

export default dexUser;
